import React from 'react'
import Tr from 'translations/Translations';
import GetAppIcon from '@material-ui/icons/Eject';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconEjectButton(
    {
        tooltip = Tr('eject'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={GetAppIcon}
        {...props}
    />
}

WorkableIconEjectButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconEjectButton;